import { displayDateNoYear, getSurgeryTypeAbbreviation, getSurgeryTypeColorClass } from "../../helper-functions";
import { Person, Surgery, Tissue } from "../../models";

interface SurgeryThumbnailProps {
    surgery?: Surgery;
    surgeon?: Person;
    tissue?: Tissue;
    withTissue?: boolean;
    withColor?: boolean;
    onClick?: () => void;
    className?: string;
}

export function SurgeryThumbnail({
    surgery,
    surgeon,
    tissue,
    withTissue,
    withColor,
    onClick,
    className,
}: Readonly<SurgeryThumbnailProps>) {
    return (
        <div onClick={onClick} className={`${withColor ? getSurgeryTypeColorClass(surgery) : ""} ${className}`}>
            <div>
                {displayDateNoYear(surgery?.scheduledOnUtc)} {surgeon?.firstName.charAt(0) ?? ""}.{" "}
                {surgeon?.lastName ?? ""} {getSurgeryTypeAbbreviation(surgery)}
            </div>
            <div>
                {surgery?.recipientAge ?? ""} {surgery?.recipientLastName ?? ""}
            </div>
            <div>{withTissue ? tissue?.number ?? "" : ""}</div>
        </div>
    );
}
